export default [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/app/',
    menu: true,
    meta: {
      anonymousAuth: false,
      requiresMfa: true
    }
  },
  {
    title: 'Regras de Bloqueio',
    icon: 'fas fa-ban',
    path: '/controleendpoint',
    view: 'ControleEndpoint',
    dir: 'views/app/ControleEndpoint/',
    menu: true,
    meta: {
      anonymousAuth: false,
      requiresMfa: true
    }
  },
  {
    path: '/mfa/validar',
    view: 'MfaValidar',
    dir: 'views/',
    title: 'Validação MFA',
    menu: false,
    meta: {
      anonymousAuth: true,
      allowTempMfa: true
    }
  },
  {
    path: '/mfa/cadastro',
    view: 'MfaCadastro',
    dir: 'views/',
    title: 'Cadastro MFA',
    menu: false,
    meta: {
      anonymousAuth: true,
      allowTempMfa: true
    }
  },
  {
    path: '/',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/auth/callback',
    view: 'AuthCallback',
    title: 'Autenticando',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '*',
    view: 'NotFound',
    dir: 'views/',
    title: 'Não Autorizado',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }
]
